var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// React
import React from "react";
// Redux
import * as redux from "redux";
import { connect } from "react-redux";
// 
import * as Actions from "office/reports/agents/actions";
import * as Selector from "office/reports/agents/selector";
// Table related
import FullTable from "common/ui/components/table/FullTable";
import * as RenderAs from "common/ui/components/table/renderAs";
import { ColumnSize, ColumnAlign, ColumnMeta } from "common/ui/components/table/ColumnMeta";
import Page from "common/ui/components/page/Page";
import PageHeading from "common/ui/components/page/PageHeading";
import PageContainer from "common/ui/components/page/PageContainer";
import ReportDatePicker from "common/ui/components/datePicker/ReportDatePicker";
// Utils
import NamingHelper from "common/utils/namingHelper";
import DateHelper from "common/utils/DateHelper";
import * as ServerPaths from "common/utils/serverPaths";
import * as reportHelper from "common/utils/reportHelper";
import DateRangeWarning from "common/ui/components/dateRangeWarning/DateRangeWarning";
const mapStateToProps = (state, props) => ({
    report: Selector.reportSelector(state)
});
const mapDispatchToProps = (dispatch) => ({
    actions: redux.bindActionCreators(Actions, dispatch)
});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
let AgentsReportView = class AgentsReportView extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        // Only fetch data if we need to
        if (reportHelper.getIfNeedsOfficeData(this.props.params.officeId, this.props.report)) {
            this.props.actions.getForced(this.props.params.officeId);
        }
    }
    render() {
        let { report } = this.props;
        let { reportData } = report;
        let isFetching = report.isFetching;
        let items = [];
        let fromDate = null;
        let toDate = null;
        let officeId = -1;
        if (report.reportData) {
            fromDate = reportData.startDate;
            toDate = reportData.endDate;
            officeId = reportData.officeId;
        }
        if (!report.isFetching) {
            items = reportData.items;
        }
        //-- Column meta data
        let metaData = [];
        metaData.push(new ColumnMeta(1, "name", "Agent Name", ColumnSize.fill).component(RenderAs.renderAsLongText).headerProps({ tip: "The name of the agent" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(2, "numNewListings", "New Listings", ColumnSize.fill, ColumnAlign.center).component(RenderAs.renderAsFormattedNumber).customCompareFn(item => item).headerProps({ tip: "The number of new unqiue listings for the agent, in the given date range" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(3, "totalListings", "Total Listings", ColumnSize.fill, ColumnAlign.center).component(RenderAs.renderAsFormattedNumber).customCompareFn(item => item).headerProps({ tip: "Total number of the agent's unique listings, in the given date range" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(4, "numViews", "Views", ColumnSize.fill, ColumnAlign.center).component(RenderAs.renderAsFormattedNumber).customCompareFn(item => item).headerProps({ tip: "Total number of views received by the agent (Listings & Branded Agent Page & Developments), in the given date range" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(5, "numTotalLeads", "Total Leads", ColumnSize.fill, ColumnAlign.center).component(RenderAs.renderAsFormattedNumber).customCompareFn(item => item).headerProps({ tip: "Total number of leads received by the agent (Listings & Branded Agent Page & Developments), in the given date range (Total Leads = Telephone Leads + Message leads)" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(6, "numPhoneLeads", "Telephone Leads", ColumnSize.fill, ColumnAlign.center).component(RenderAs.renderAsFormattedNumber).customCompareFn(item => item).headerProps({ tip: "Total number of telephone leads received by the agent (Listings & Branded Agent Page & Developments), in the given date range" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(7, "numMessageLeads", "Message Leads", ColumnSize.fill, ColumnAlign.center).component(RenderAs.renderAsFormattedNumber).customCompareFn(item => item).headerProps({ tip: "Total number of message leads received by the agent (Listings & Branded Agent Page & Developments), in the given date range" }).toReportColumnMeta());
        metaData.push(new ColumnMeta(8, "averageListingScore", "Avg Quality Score", ColumnSize.fill, ColumnAlign.center).headerProps({ tip: "The average quality score for all of the agent's listings, in the given date range" }).customCompareFn(item => item).toReportColumnMeta());
        //-- Handle date change
        let datePick = (fromDate, toDate) => {
            this.props.actions.getForced(reportData.officeId, fromDate, toDate, false);
        };
        let ranges = {
            'Last 7 Days': DateHelper.getLast7Days(),
            'Last 30 Days': DateHelper.getLast30Days(),
            'This Month': DateHelper.getThisMonth(),
            'Last Month': DateHelper.getLastMonth()
        };
        let datePickerComponent = (React.createElement(ReportDatePicker, { fromDate: fromDate, toDate: toDate, isFetching: isFetching, dateRange: ranges, onSelect: (from, to) => datePick(from, to) }));
        return (React.createElement(Page, null,
            React.createElement(PageHeading, { reportName: NamingHelper.officeAgents, datePicker: datePickerComponent },
                React.createElement("a", { target: "_blank", href: ServerPaths.officeAgentsRequestCsvParams(officeId, fromDate, toDate) }, "Export")),
            React.createElement(PageContainer, { isFetching: isFetching },
                React.createElement(DateRangeWarning, { fromDate: fromDate, toDate: toDate }),
                React.createElement(FullTable, { reportItems: items, metaData: metaData, excludeColumns: ["numNewListings"], excludeColumnsFromFilter: ["numNewListings", "totalListings", "numViews",
                        "numTotalLeads", "numPhoneLeads", "numMessageLeads", "averageListingScore"] }))));
    }
};
AgentsReportView = __decorate([
    connect(mapStateToProps, mapDispatchToProps)
], AgentsReportView);
export default AgentsReportView;
